export default __webpack_public_path__ + "static/media/img-0555-denmark-half-face.73eafc1f.png";